/**
 * Arms the frontend-kernel `requiresModule` gate for the single country-bound
 * entry this app has: VeriFactu is a purely spanish obligation, so its sidebar
 * item under „Einstellungen" only makes sense for an ES organisation.
 *
 * The kernel has no country predicate on navigation items, but it does have
 * `registry.setEnabledModules()`. So the gate is armed with an empty set right
 * away — the item stays hidden by default, no flash for the non-spanish
 * majority — and `verifactu` is switched on once `organization.current`
 * reports ES.
 *
 * Asked only with an active organisation: without one `organization.current`
 * answers NOT_FOUND (Plan ALLGEMEIN 2026-09-26/01, S4 part 1).
 *
 * Kill-switch: drop this wrapper from `saas.config.ts` and the gate goes
 * no-op, i.e. every `requiresModule` item becomes visible again.
 */
import { useActiveOrganizationId, usePluginRegistry } from '@xhubio-saas/core-frontend/kernel'
import { type ReactNode, useEffect } from 'react'
import { trpc } from '@/trpc'

export function VerifactuNavGate({ children }: { children: ReactNode }) {
  const activeOrganizationId = useActiveOrganizationId()
  const { registry } = usePluginRegistry()
  const { data } = trpc.organization.current.useQuery(undefined, {
    enabled: !!activeOrganizationId,
    staleTime: 5 * 60 * 1000,
  })

  useEffect(() => {
    registry.setEnabledModules(data?.countryCode === 'ES' ? ['verifactu'] : [])
  }, [data?.countryCode, registry])

  return <>{children}</>
}
